import React from "react";
import { Badge } from "reactstrap";

const SpaAppointmentStatusBadge = ({ status }) => {
  let color;
  let displayText;

  switch (status) {
    case "COMPLETED":
      color = "success"; // Green
      displayText = "Completed";
      break;
    case "PENDING":
      color = "warning"; // Yellow/Orange
      displayText = "Pending";
      break;
    case "CANCELLED":
      color = "danger"; // Red
      displayText = "Cancelled";
      break;
    case "IN_PROGRESS":
      color = "info"; // Blue
      displayText = "In Progress";
      break;
    case "CONFIRMED":
      color = "primary"; // Blue
      displayText = "Confirmed";
      break;
    default:
      color = "light"; // Light gray for unknown status
      displayText = status || "Unknown";
  }

  return (
    <Badge 
      color={color} 
      style={{ 
        padding: "6px 12px", 
        fontSize: "12px",
        fontWeight: "500",
        borderRadius: "20px"
      }}
    >
      {displayText}
    </Badge>
  );
};

export default SpaAppointmentStatusBadge;
